const config = {
	pageSize: 10,
};

export default config;
